import error, { getErrorObject } from '../../helpers/error';
import { toPrismicLang } from '../../helpers/i18n';
import { HTTP_CLIENT_ERROR_NOT_FOUND } from '../../helpers/http';

import { getByID } from '../../api/prismic';

import { handleError } from '../errors';

import { ERROR } from 'translations';

export const LOAD_DOCUMENT_BY_ID_REQUEST = 'LOAD_DOCUMENT_BY_ID_REQUEST';
export const LOAD_DOCUMENT_BY_ID_SUCCESS = 'LOAD_DOCUMENT_BY_ID_SUCCESS';
export const LOAD_DOCUMENT_BY_ID_FAILURE = 'LOAD_DOCUMENT_BY_ID_FAILURE';

export const loadDocumentByIdRequest = (lang, id) => ({
  type: LOAD_DOCUMENT_BY_ID_REQUEST,
  lang,
  id,
});

export const loadDocumentByIdSuccess = (lang, id, document) => ({
  type: LOAD_DOCUMENT_BY_ID_SUCCESS,
  payload: document,
  lang,
  id,
});

export const loadDocumentByIdFailure = (lang, id, error) => ({
  type: LOAD_DOCUMENT_BY_ID_FAILURE,
  payload: getErrorObject(error, ERROR.ERROR_LOADING_DOC_BY_ID, { id }),
  lang,
  id,
});

export const getDocumentById = (id) => async (dispatch, getState) => {
  const { locale } = getState();
  const lang = toPrismicLang(locale);

  try {
    dispatch(loadDocumentByIdRequest(locale, id));

    const document = await getByID(id, { lang });
    if (!document) {
      throw error(
        HTTP_CLIENT_ERROR_NOT_FOUND,
        `Document with id "${id}" couldn't be found`
      );
    }

    dispatch(loadDocumentByIdSuccess(locale, id, document));
  } catch (error) {
    const fallback = loadDocumentByIdFailure(locale, id, error);
    handleError(dispatch, error, fallback);
  }
};
